export const MASTER_REVISION_INSTRUCTION_FIELDS = Object.freeze([
  ['master-revision-general', 'general'],
  ['master-revision-title', 'title'],
  ['master-revision-bullets', 'bullets'],
  ['master-revision-description', 'description'],
  ['master-revision-aplus', 'aplus'],
  ['master-revision-qa', 'qa'],
  ['master-revision-searchTerms', 'searchTerms'],
]);

/**
 * Keeps the Step6 merchant instruction form in sync with restored state.
 *
 * The controller deliberately stores the user's untrimmed input. Trimming is
 * an execution concern in collect(), so a restored draft is never rewritten
 * merely because the user revisits the optimization step.
 */
export function createRevisionMasterInstructionsController({
  getState,
  setState,
  getElementById,
  onStateChanged = () => {},
} = {}) {
  const getElement = (id) => getElementById?.(id) || null;

  function collect() {
    return Object.fromEntries(MASTER_REVISION_INSTRUCTION_FIELDS.map(([id, key]) => [
      key,
      String(getElement(id)?.value || '').trim(),
    ]));
  }

  function sync() {
    const instructions = getState?.('masterRevisionInstructions') || {};
    for (const [id, key] of MASTER_REVISION_INSTRUCTION_FIELDS) {
      const element = getElement(id);
      const value = String(instructions[key] || '');
      if (element && element.value !== value) element.value = value;
    }
  }

  function bind() {
    for (const [id, key] of MASTER_REVISION_INSTRUCTION_FIELDS) {
      const element = getElement(id);
      if (!element) continue;
      element.addEventListener('input', () => {
        const previous = getState?.('masterRevisionInstructions') || {};
        setState?.('masterRevisionInstructions', {
          ...previous,
          [key]: element.value,
        });
        onStateChanged();
      });
    }
  }

  return {
    bind,
    collect,
    sync,
  };
}
